"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDoubleTTranslation = exports.instance = void 0;

var _i18next = _interopRequireDefault(require("i18next"));

var _reactI18next = require("react-i18next");

var _reactLoudspeaker = _interopRequireDefault(require("../i18n/locales/en-US/react-loudspeaker.json"));

var _reactLoudspeaker2 = _interopRequireDefault(require("../i18n/locales/fr-FR/react-loudspeaker.json"));

var _reactLoudspeaker3 = _interopRequireDefault(require("../i18n/locales/de-DE/react-loudspeaker.json"));

var _reactLoudspeaker4 = _interopRequireDefault(require("../i18n/locales/nl-NL/react-loudspeaker.json"));

var _reactLoudspeaker5 = _interopRequireDefault(require("../i18n/locales/it-IT/react-loudspeaker.json"));

var _reactLoudspeaker6 = _interopRequireDefault(require("../i18n/locales/ja-JP/react-loudspeaker.json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const instance = _i18next.default.createInstance();

exports.instance = instance;
instance.init({
  lng: 'en',
  fallbackLng: 'en',
  load: 'currentOnly',
  defaultNS: 'translations',
  react: {
    useSuspense: false
  },
  resources: {
    en: {
      translations: _reactLoudspeaker.default
    },
    fr: {
      translations: _reactLoudspeaker2.default
    },
    de: {
      translations: _reactLoudspeaker3.default
    },
    nl: {
      translations: _reactLoudspeaker4.default
    },
    it: {
      translations: _reactLoudspeaker5.default
    },
    ja: {
      translations: _reactLoudspeaker6.default
    }
  }
});

const useDoubleTTranslation = language => {
  const {
    t
  } = (0, _reactI18next.useTranslation)(undefined, {
    i18n: instance
  });

  const tt = (key, options) => {
    return t(key, _objectSpread(_objectSpread({}, options), {}, {
      lng: language || 'en'
    }));
  };

  return {
    i18n: _i18next.default,
    tt
  };
};

exports.useDoubleTTranslation = useDoubleTTranslation;